package br.com.vvrefeicoes.portal.domain.repository

import br.com.vvrefeicoes.portal.domain.model.AuditEntry

interface AuditRepository {
    suspend fun loadEntries(
        page: Int,
        size: Int,
        from: String? = null,
        to: String? = null,
        query: String? = null,
    ): AuditPage

    suspend fun getEntry(id: String): AuditEntry
}

data class AuditPage(
    val entries: List<AuditEntry>,
    val totalPages: Int,
)
